import { RootState } from "store/reducers/main";
import { FeatureFlagsEnum } from "types/working-model";

export const selectFeatureFlag = (flag: FeatureFlagsEnum) =>
	(state: RootState) => state.FeatureFlagsReducer.featureFlags[flag];

export const selectUseConfirmationUrls = selectFeatureFlag(FeatureFlagsEnum.integrations_confirmation_urls);

export const selectUseSsoAttrMapping = selectFeatureFlag(FeatureFlagsEnum.sso_attr_mapping_2025);
export const selectEditorNavV3 = (state: RootState) => {
	if (process.env.REACT_APP_STAGE === 'local' && localStorage.getItem('force-v3')) {
		return true;
	}

	const userChannelType = state.AuthReducer.userChannelType;
	if (!userChannelType || userChannelType === 'unset') {
		return false;
	}

	return true;
};
export const selectUiAiCaptions = selectFeatureFlag(FeatureFlagsEnum.ui_ai_captions);
export const selectProjectTitleSync = selectFeatureFlag(FeatureFlagsEnum.project_title_sync);
export const selectModeratorClaimsFeatureFlag = selectFeatureFlag(FeatureFlagsEnum.moderator_claims);
